import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight } from 'lucide-react';

const EmailConfirmation = () => {
  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 bg-dark-base">
      <div className="max-w-md w-full bg-dark-card rounded-lg shadow-xl p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-green-500/10 rounded-full p-3">
            <CheckCircle className="h-12 w-12 text-green-500" />
          </div>
        </div>

        <h1 className="text-2xl font-bold text-white mb-4">
          ¡Gracias por confirmar tu email!
        </h1>

        <p className="text-gray-300 mb-8">
          Tu cuenta ha sido verificada correctamente. Ahora puedes acceder a todas las funcionalidades de Asistente Trading IA.
        </p>

        <div className="space-y-4">
          <Link 
            to="/login" 
            className="btn-primary w-full inline-flex items-center justify-center"
          >
            Iniciar Sesión
            <ArrowRight className="ml-2 h-5 w-5" />
          </Link>

          <p className="text-sm text-gray-400">
            Si tienes alguna pregunta, no dudes en{' '}
            <a 
              href="mailto:info@asistentetradingia.com" 
              className="text-primary hover:text-primary-hover"
            >
              contactarnos
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailConfirmation;